import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  GetEnumValuesDto,
  GetSmartSmsCampaignStatusInGatewayDto,
} from '../../../../core/api/models';
import { SmartSmsCampaignsService } from '../../../../core/api/services';
import { EventTypes } from '../../../../core/constants/event-types';
import { TranslationModule } from '../../../../i18n/translation.module';
import { ShareModule } from '../../../../shared/share.module';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { PagesSharedModule } from '../../../shared/pages-shared.module';

@Component({
  selector: 'app-campaign-status-in-gateway',
  templateUrl: './campaign-status-in-gateway.component.html',
  imports: [
    CommonModule,
    ShareModule,
    TranslationModule,
    ReactiveFormsModule,
    FormsModule,
    PagesSharedModule,
  ],
})
export class CampaignStatusInGatewayComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region porperties

  @Input() campaignId: number;
  @Input() campaignTitle: number;

  SmsAggregatorEnumValues: GetEnumValuesDto[] = [];
  items: Array<GetSmartSmsCampaignStatusInGatewayDto> = [];

  @Output('closePage') output_closePage = new EventEmitter<boolean>();

  //#endregion
  constructor(protected currentService: SmartSmsCampaignsService) {
    super();
  }
  //#region init methods

  ngOnInit() {
    try {
      this.getVocabs();
      this.configTableColumns();
      this.initTablePagination();
      this.configPage();
      this.getTableData();
      this.getEnumsValues();
      this.pageConfig.title = 'common.campaignStatusInGateway';
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.tableConfig.showOperationColumn = false;
      this.pageConfig.tableConfig.hidePagination = true;
      this.pageConfig.tableConfig.hidePageSize = true;
      this.pageConfig.showRefreshBtn = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  configTableColumns(): void {
    this.tableColumns = [
      {
        title: this.localizer.id,
        name: 'grayListId',
        type: 'number',
        noSorting: true,
        hasSearch: false,
      },
      {
        title: 'common.operator',
        name: 'operator',
        type: 'enum',
        enumName: 'SmsAggregator',
        noSorting: true,
        hasSearch: false,
      },

      {
        title: 'common.isCreated',
        name: 'isCreated',
        type: 'boolean',
        noSorting: true,
        hasSearch: false,
        wrap: true,
      },
    ];
  }

  //#endregion
  //#region api

  getTableData() {
    this.unSubs();
    this.pageConfig.loading = true;
    this.currentService
      .smartSmsCampaignsGetSmartSmsCampaignStatusInGateway({
        SmartSmsCampaignId: this.campaignId,
      })
      .pipe(this.basePipeOperators())
      .subscribe((result) => {
        this.items = Object.assign([], result?.data);
      });
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsAggregator')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsAggregatorEnumValues = values));
  }

  addSmartSmsCampaignToGatewayApi(operator) {
    this.unSubs();
    this.loading = true;
    this.currentService
      .smartSmsCampaignsAddSmartSmsCampaignToGateway({
        body: { id: this.campaignId, mobileOperator: operator },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }
  //#endregion

  onClose() {
    this.output_closePage.emit(true);
  }

  getPaginationApi(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  onAddSmartSmsCampaignToGateway(operator) {
    this.addSmartSmsCampaignToGatewayApi(operator);
  }
}
